import React, { useState, FocusEvent } from "react";
import { Button } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { ActionHandlerFunction } from "@preveil-api";
import { CheckboxStates, DriveUIActionTypes, DriveSearchFilterType, DriveEntryType, DriveMessages } from "src/common";
import { Checkbox } from "src/components";
import { SearchExtensionFilter } from ".";
import _ from "lodash";

type AllProps = {
  search_term?: string;
  searching: boolean;
  handleAction: ActionHandlerFunction;
}


function SearchTypeFilterComponent(props: AllProps) {
  const { searching, handleAction } = props;
  const [files_active, setFilesActive] = useState<boolean>(true);
  const [dir_active, setDirActive] = useState<boolean>(true);
  const [link_active, setLinkActive] = useState<boolean>(true);
  const [extensions_active, setExtensionsActive] = useState<string[]>([]);

  // Description: set all back to defaults on clear
  function resetDefaults() {
    handleAction({ actionType: DriveUIActionTypes.ResetFilters, params: DriveSearchFilterType.fs_type });
    setFilesActive(true);
    setDirActive(true);
    setLinkActive(true);
    setExtensionsActive([]);
  }

  // Description: Add Extension to keep checked state 
  function setExtensionsActiveState(extension: string, active: boolean) {
    const new_ext = extensions_active.slice();
    const index = _.findIndex(new_ext, (_extension) => (_extension === extension));
    index < 0 && active ? new_ext.push(extension) :
      (index >= 0 && !active && new_ext.splice(index, 1));
    setExtensionsActive(new_ext);
    handleAction({
      actionType: DriveUIActionTypes.SetFilter,
      params: { filter_type: DriveSearchFilterType.extension, extension, active }
    });
  }

  return <section
    className={searching ? "disabled" : ""}>
    <header>
      <h5>Filter by Type</h5>
      <Button variant="link" size="sm"
        onClick={resetDefaults}>
        Clear Filters
      </Button>
    </header>
    <ul>
      <li
        data-tooltip-id="filter-tooltip"
        data-tooltip-place="left"
        data-tooltip-content={!link_active && !files_active ? DriveMessages.filter_required_tooltip : "Filter results by folders"}>
        <Checkbox
          disabled={!link_active && !files_active}
          className={dir_active && !link_active && !files_active ? "selected" : ""}
          selected={dir_active ? CheckboxStates.checked : CheckboxStates.empty}
          value="folders" label="Folders"
          onChange={(e: FocusEvent<HTMLInputElement>) => {
            setDirActive(e.target.checked);
            handleAction({
              actionType: DriveUIActionTypes.SetFilter,
              params: { filter_type: DriveSearchFilterType.fs_type, fs_type: DriveEntryType.DIR, active: e.target.checked }
            });
          }} />
      </li>
      <li data-tooltip-id="filter-tooltip"
        data-tooltip-place="left"
        data-tooltip-content={!dir_active && !files_active ? DriveMessages.filter_required_tooltip : "Filter results by Shared Folders"}>
        <Checkbox
          disabled={!dir_active && !files_active}
          className={link_active && !dir_active && !files_active ? "selected" : ""}
          selected={link_active ? CheckboxStates.checked : CheckboxStates.empty}
          value="shared" label="Shared Folders"
          onChange={(e: FocusEvent<HTMLInputElement>) => {
            setLinkActive(e.target.checked);
            handleAction({
              actionType: DriveUIActionTypes.SetFilter,
              params: { filter_type: DriveSearchFilterType.fs_type, fs_type: DriveEntryType.LINK, active: e.target.checked }
            });
          }} />
      </li>
      <li
        data-tooltip-id="filter-tooltip"
        data-tooltip-place="left"
        data-tooltip-content={!dir_active && !files_active ? DriveMessages.filter_required_tooltip : "Filter results by Files and file types"}>
        <Checkbox
          disabled={!dir_active && !link_active}
          className={files_active && !dir_active && !link_active ? "selected" : ""}
          selected={files_active ? CheckboxStates.checked : CheckboxStates.empty}
          value="files" label="Files"
          onChange={(e: FocusEvent<HTMLInputElement>) => {
            const active = e.target.checked;
            setFilesActive(active); // NOTE: Reset Extensions if FILES are not active
            if (!active) {
              setExtensionsActive([]);
              handleAction({ actionType: DriveUIActionTypes.ResetFilters, params: DriveSearchFilterType.extension });
            }
            handleAction({
              actionType: DriveUIActionTypes.SetFilter,
              params: { filter_type: DriveSearchFilterType.fs_type, fs_type: DriveEntryType.FILE, active }
            });
          }} />
      </li>
      <li className="file-extensions" hidden={!files_active}>
        <SearchExtensionFilter
          extensions_active={extensions_active}
          setExtensionsActiveState={setExtensionsActiveState} />
      </li>
    </ul>
    {searching && <div className="mask"></div>}

    {/* Need its own Tooltip for closing issues */}
    <Tooltip
      id="filter-tooltip"
      disableStyleInjection="core"
      closeEvents={{
        mouseleave: true,
        blur: true,
        click: true,
        dblclick: true,
        mouseup: true,
      }} />
  </section>;
}

export default React.memo(SearchTypeFilterComponent);
